import operateAttrProps from "../config/operate";
import store from "../store";

/**处理运营中心列表数据
 * [
 *  {region: 北培, KPI: 钻石业绩, Today: 123, MTD: 123, YTD: 123},
 *  {region: 成都, KPI: 素金业绩, Today: 123, MTD: 123, YTD: 123},
 * ]
 *
 * ==>
 *
 * regionList: [北培， 成都]
 * todayList: [zs: 123, sj: 123]
 * mtdList: [zs: 123, sj: 123]
 * ytdList: [zs: 123, sj: 123]
 *
 * */
export function formatOperateList(rows) {
  let obj = {};
  let regionList = [];
  rows.forEach((v, i) => {
    // 过滤掉门店数据
    if (v.Region !== v.Shop) return;
    let key = operateAttrProps[v.KPI] || v.KPI;
    if (!key) return;
    if (obj[v.Region]) {
      obj[v.Region].today[key] = v.Today;
      obj[v.Region].mtd[key] = v.MTD;
      obj[v.Region].ytd[key] = v.YTD;
    } else {
      obj[v.Region] = {
        today: {
          [key]: v.Today,
        },
        mtd: {
          [key]: v.MTD,
        },
        ytd: {
          [key]: v.YTD,
        },
      };
      regionList.push({
        region: v.Region,
        shop: v.Shop,
        id: i + 1,
        name: v.Region,
      });
    }
  });
  let todayList = [];
  let mtdList = [];
  let ytdList = [];
  Object.keys(obj).forEach((v, i) => {
    todayList.push({ regionId: i + 1, region: v, ...obj[v].today });
    mtdList.push({ regionId: i + 1, region: v, ...obj[v].mtd });
    ytdList.push({ regionId: i + 1, region: v, ...obj[v].ytd });
  });
  return { regionList, tableData: [todayList, mtdList, ytdList] };
}

// 过滤掉没有权限的区域和门店
export function filterRegionShop(rows) {
  const { region, shop } = store.state.permission;
  return rows.filter((v) => {
    if (v.Region === v.Shop) {
      // 区域
      return region.includes(v.Region);
    } else {
      return shop.some((item) => item.shop === v.Shop);
    }
  });
}
